export default __webpack_public_path__ + "static/hardware-9a100e47a30a8773f2b0fb480dae9552.png";